import addressForm from './addressForm.json';
import alerts from './alerts.json';
import createCustomer from './createCustomer.json';
import createNew from './createNew.json';
import gridButtons from './gridButtons.json';
import layaway from './layaway.json';
import modalpage from './modalpage.json';
import offer from './offer.json';
import payCheckForm from './payCheckForm.json';
import payment from './payment.json';
import pluginCustomerDisplay from './plugin-customerDisplay.json';
import returnTranslations from './return.json';
import search from './search.json';
import settingsCompany from './settingsCompany.json';
import settingsConfiguration from './settingsConfiguration.json';
import settingsCustomer from './settingsCustomer.json';
import settingsCustomerSearchResults from './settingsCustomerSearchResults.json';
import settingsLanguage from './settingsLanguage.json';
import settingsPayment from './settingsPayment.json';
import settingsUserInterface from './settingsUserInterface.json';
import shipping from './shipping.json';

export const enAU = {
  addressForm,
  alerts,
  createCustomer,
  createNew,
  gridButtons,
  layaway,
  modalpage,
  offer,
  payment,
  payCheckForm,
  'plugin-customerDisplay': pluginCustomerDisplay,
  return: returnTranslations,
  search,
  settingsCompany,
  settingsConfiguration,
  settingsCustomer,
  settingsCustomerSearchResults,
  settingsLanguage,
  settingsPayment,
  settingsUserInterface,
  shipping,
};
